import { createFileRoute } from '@tanstack/react-router';
import { SampleSetToolbarLayout } from '../../../../../pages/experiments/SampleSetToolbarLayout';

export const Route = createFileRoute(
  '/_authenticated/_navbar/experiments/$sampleSetId/_toolbar'
)({
  component: SampleSetToolbarLayout,
});
